import React, {useEffect, useRef, useState} from 'react';
import './select-menu.scss';
import classNames from '../../lib/class-names';
import {originatesFromMenu} from '../popup/util';

type Props = {
    label: string,
    children: React.ReactNode | Array<React.ReactNode>
};

export default function SelectMenu(props: Props) {
    const {label} = props;
    const [menuOpen, setMenuOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const listener = (e: MouseEvent) => {
            const isFromMenu = originatesFromMenu(e.target as HTMLElement);
            const isFromButton = buttonRef.current === e.target;
            if (!isFromMenu && !isFromButton) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('click', listener);
        return () => window.removeEventListener('click', listener);
    }, []);

    return <div className="relative inline-block">
        <div className="select-holder">
            <button className={classNames('select', {'is-darkened': menuOpen})} ref={buttonRef}
                onClick={() => setMenuOpen(!menuOpen)} aria-controls="popup-menu" aria-expanded={menuOpen ? 'true' : 'false'}>
                {label}
            </button>
        </div>

        {menuOpen && <div className="select-menu-popup" onClick={e => e.stopPropagation()}>
            {props.children}
        </div>}
    </div>;
}